import { render, staticRenderFns } from "./sliderThumbs.vue?vue&type=template&id=a926c1ec"
import script from "./sliderThumbs.vue?vue&type=script&lang=js"
export * from "./sliderThumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports